import { Link } from 'react-router-dom';

import { NAV_LINKS, ROUTES, SECTION_IDS, SERVICE_QUERY_PARAM } from '../../core/constants/navigation';
import { SITE_SLOGAN } from '../../core/constants/seo';
import { SERVICES } from '../../core/constants/services';
import { meta, site } from '../../global/config/site';
import BrandLogo from '../../common/components/BrandLogo/BrandLogo';
import { IconGlobe, IconMail, IconMapPin } from '../../common/icons';
import CHANGELOG from './changelog';

import './styles/footer.css';

const CURRENT_VERSION = CHANGELOG[0].version;
const CURRENT_YEAR = new Date().getFullYear();

export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer__inner layout-container">
                <div className="footer__brand">
                    <Link to={ROUTES.HOME} className="footer__logo">
                        <BrandLogo isInverted />
                        <span className="visually-hidden">, ir al inicio</span>
                    </Link>
                    <p className="footer__slogan">{SITE_SLOGAN}</p>
                    <p className="footer__text">
                        Asesoría integral, marketing digital, producción audiovisual y desarrollo web para medios y marcas.
                    </p>
                </div>

                <nav className="footer__column" aria-label="Secciones">
                    <h2 className="footer__title">Explora</h2>
                    <ul className="footer__list">
                        {NAV_LINKS.map(link => (
                            <li key={link.id}>
                                <Link to={{ pathname: ROUTES.HOME, hash: `#${link.id}` }} className="footer__link">{link.label}</Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <nav className="footer__column" aria-label="Servicios">
                    <h2 className="footer__title">Servicios</h2>
                    <ul className="footer__list">
                        {SERVICES.map(service => (
                            <li key={service.id}>
                                <Link
                                    to={{ pathname: ROUTES.HOME, search: `?${SERVICE_QUERY_PARAM}=${service.id}`, hash: `#${SECTION_IDS.CONTACT}` }}
                                    className="footer__link"
                                >
                                    {service.shortTitle}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </nav>

                <div className="footer__column">
                    <h2 className="footer__title">Contacto</h2>
                    <ul className="footer__list">
                        <li className="footer__contact">
                            <IconMail />
                            <a href={`mailto:${site.contactEmail}`} className="footer__link">{site.contactEmail}</a>
                        </li>
                        <li className="footer__contact">
                            <IconGlobe />
                            <span>{site.domain}</span>
                        </li>
                        <li className="footer__contact">
                            <IconMapPin />
                            <span>Colombia</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="footer__bottom layout-container">
                <p className="footer__copy">© {CURRENT_YEAR} {meta.projectName}. Todos los derechos reservados.</p>
                <div className="footer__legal">
                    <Link to={ROUTES.PRIVACY} className="footer__link">Política de tratamiento de datos</Link>
                    <span className="footer__version" title="Versión del sitio">{CURRENT_VERSION}</span>
                </div>
            </div>
        </footer>
    );
}
